module.exports = __webpack_public_path__ + "static/pexels-oles-kanebckuu-127873-840f1ae87416cafd18bd93f203991e92.jpg";